import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Persistor from '../store/Persistor';

import { useSelector } from "react-redux";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

import { loggedOut, setLoggedOut } from "../auth/authReducer";
import { selectCurrentUser } from "../auth/authReducer";
import { selectCollapsed } from "../ui/sidebarCollapseReducer";

import Sidebar from "./Sidebar";

import voltupLogo from "../../assets/voltup-logo.png";

import { currentLoadingState } from "../ui/loadingStateReducer"
import Loading from './Loading'

import { ToastContainer } from "react-toastify";

const AppLayout = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const sidebarCollapsed = useSelector(selectCollapsed);
  const isLoading = useSelector(currentLoadingState)

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(setLoggedOut(loggedOut()));
    Persistor.removeAll();
    navigate("/");
  };

  // if(isLoading) {
  //   return <Loading />
  // }

  return (
    <div
      className={`app-layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}
    >
      {isLoading && <Loading />}
      <Navbar
        expand="lg"
        className="topbar shadow-sm bg-body-tertiary sticky-top"
      >
        <Container fluid>
          <Navbar.Brand href="" className="ms-4">
            <img alt="voltup-logo" src={voltupLogo} style={{ width: "80px" }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" 
           style={{height: '35px', width: '40px', padding: '0'}}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
            </Nav>
            <Nav>
              <Navbar.Text className="me-2">
                Hii, <strong>{currentUser.name}</strong>!
              </Navbar.Text>
              <Nav.Link href="" onClick={handleLogout}>
                Logout
                <FontAwesomeIcon icon={faRightFromBracket} className="ms-2" />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="content-wrapper bg-light">
        <Sidebar searchQueryVisible={true}/>
        <Container className="content" fluid>
          {props.children}
        </Container>
      </div>
      <ToastContainer />
    </div>
  );
};

export default AppLayout;
